<script>
export default {
  name: "EffContractTeacherDataList",
  props: {
    surname: {
      type: String,
      required: true
    },

    name: {
      type: String,
      required: true
    },

    patronymic: {
      type: String,
      default: null
    },

    degree: {
      type: String,
      required: true,
    },

    bid: {
      type: [String, Number],
      required: true,
    },

    dean: {
      type: Boolean,
      required: true,
    },

    headDepartment: {
      type: Boolean,
      required: true,
    },

    width: {
      type: String,
      default: "100%",
    }
  },

  data() {
    return {
    };
  },

  computed: {
    surnameAndInitial() {
      try {
        let fullName = this.surname + " " + this.name[0] + "."
        if (!_.isNil(this.patronymic) && !_.isEmpty(this.patronymic)) {
          fullName += this.patronymic[0] + "."
        }
        return fullName
      } catch (e) {
        console.warn(e);
      }
    },

    stringBid() {
      if (Number(this.bid) === 1.00) {
        return "Полная"
      } else {
        return `Неполная (${this.bid})`
      }
    },

    statusDean() {
      return this.dean ? "Является" : "Не является"
    },

    statusHeadDepartment() {
      return this.headDepartment ? "Является" : "Не является"
    }
  },
}
</script>

<template>
  <v-sheet :width="width">
    <p class="text-h5">{{surnameAndInitial}}</p>
    <v-list class="d-flex pa-0">
      <v-row no-gutters class="pa-0">
        <v-col cols="12" md="6">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle>Должность</v-list-item-subtitle>
              <v-list-item-title>{{degree}}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-subtitle>Ставка</v-list-item-subtitle>
              <v-list-item-title>{{stringBid}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="6">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle>Декан</v-list-item-subtitle>
              <v-list-item-title>{{statusDean}}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-subtitle>Зав. кафедрой</v-list-item-subtitle>
              <v-list-item-title>{{statusHeadDepartment}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </v-list>
  </v-sheet>
</template>

<style scoped>

</style>